import { Config } from "@/hooks/useConfig";
import { getMROIColumnSelectorLabel } from "@/pages/channel-roi/constants/maps";
import { MROIColumnSelector } from "@/pages/channel-roi/constants/types";

type ColumnViewOptions = {
  value: MROIColumnSelector;
  label: string;
}[];

export const getColumnViewOptions = (
  hasSharedRevenue: boolean,
  hasRoiNodes: boolean,
  funnelStage: string,
  config: Config
): ColumnViewOptions => {
  if (hasSharedRevenue && funnelStage === "all") return sharedRevenueAllOptions(config);
  if (hasSharedRevenue) return sharedRevenueFunnelStageOptions(config);
  if (hasRoiNodes) return roiNodesOptions(config);
  return [];
};

const sharedRevenueAllOptions = (config: Config) => [
  {
    value: MROIColumnSelector.MARKETING_RETURN_AMOUNT,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.MARKETING_RETURN_AMOUNT, config),
  },
  {
    value: MROIColumnSelector.MARKETING_RETURN_PERCENTAGE,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.MARKETING_RETURN_PERCENTAGE, config),
  },
];

const sharedRevenueFunnelStageOptions = (config: Config) => [
  {
    value: MROIColumnSelector.SHARE_OF_EFFECT_AMOUNT,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.SHARE_OF_EFFECT_AMOUNT, config),
  },
  {
    value: MROIColumnSelector.SHARE_OF_EFFECT_PERCENTAGE,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.SHARE_OF_EFFECT_PERCENTAGE, config),
  },
];

const roiNodesOptions = (config: Config) => [
  {
    value: MROIColumnSelector.ROI_PERCENTAGE,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.ROI_PERCENTAGE, config),
  },
  {
    value: MROIColumnSelector.SPEND_VS_REVENUE_AMOUNT,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.SPEND_VS_REVENUE_AMOUNT, config),
  },
  {
    value: MROIColumnSelector.SPEND_VS_REVENUE_PERCENTAGE,
    label: getMROIColumnSelectorLabel(MROIColumnSelector.SPEND_VS_REVENUE_PERCENTAGE, config),
  },
];
